export default __webpack_public_path__ + "static/media/logo.47d8bf09.svg";